import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { API_KEY } from 'src/constants/apiKey';

import quotation from 'src/repositories/quotation';

type UseEstimateManufacturingNextSizes = {
  handleSuccess: (
    res: AxiosResponse<Response.EstimateManufacturingNextSizesResponse, any>,
    args: Payload.ManufacturingImport,
  ) => void;
};

const useEstimateManufacturingNextSizes = ({
  handleSuccess,
}: UseEstimateManufacturingNextSizes) => {
  const getManufacturingNextSizes = useMutation<
    AxiosResponse<Response.EstimateManufacturingNextSizesResponse>,
    AxiosError<Response.Error>,
    Payload.ManufacturingImport
  >({
    mutationKey: [API_KEY.ESTIMATE_MANUFACTURING_NEXT_SIZES],
    mutationFn: (args) => {
      return quotation.getManufacturingImport(
        API_KEY.ESTIMATE_MANUFACTURING_NEXT_SIZES,
        args,
      );
    },
    onSuccess: (res, args) => handleSuccess(res, args),
    onError: (error) => {
      console.log(error.response);
    },
  });

  return { getManufacturingNextSizes };
};

export default useEstimateManufacturingNextSizes;
